module.exports = __webpack_public_path__ + "img/tranzactiicard-o.4ebef6db.svg";